chooseMenuItemTypeController.$inject = ['$scope', '$uibModalInstance', '$translate', 'isEditMenuItem', 'menuItem'];
export function chooseMenuItemTypeController($scope, $uibModalInstance, $translate, isEditMenuItem, menuItem) {
  $scope.selectType = selectType;
  $scope.cancel = cancel;
  $scope.submit = submit;
  $scope.delete = deleteMenuItem;

  init();

  function selectType(type) {
    $scope.menuItem.type = type;
    $scope.selectedTypeLabel = $scope.possibleMenuItemTypes.find(menuItemType => menuItemType.id === type).label; 
  }

  function submit() {
    let menuItem = {
      type: $scope.menuItem.type,
      title: $scope.menuItem.title
    };
    if (['web_url', 'postback'].includes($scope.menuItem.type)) {
      menuItem.urlOrPayload = $scope.menuItem.urlOrPayload;
    }
    $uibModalInstance.close({ type: 'edit', menuItem });
  }

  function cancel() {
    $uibModalInstance.dismiss('cancel');
  }

  function deleteMenuItem() {
    $uibModalInstance.close({ type: 'delete' });
  }

  function init() {
    $scope.menuItem = menuItem;

    $scope.isEditMenuItem = isEditMenuItem;

    $scope.persistentMenuLabel = $translate.instant('parameters/quick_replies/details/persistent_menu_type');
    $scope.possibleMenuItemTypes = [
      { 
        id: 'alcmeon_restart_conversation',
        label: $translate.instant('parameters/quick_replies/details/persistent_menu_restart')
      },
      { 
        id: 'web_url',
        label: $translate.instant('parameters/quick_replies/details/persistent_menu_url')
      },
      { 
        id: 'postback',
        label: $translate.instant('parameters/quick_replies/details/persistent_menu_postback')
      },
      { 
        id: 'postback_to_box',
        label: $translate.instant('parameters/quick_replies/details/persistent_menu_postback_to_box')
      },
    ];

    selectType($scope.menuItem.type);
  }

}
